import { Trans } from '@lingui/react/macro';
import { useMemo } from 'react';

import { type CampaignActivityDataType } from '@/api/campaign';
import { Button, LinkButton } from '@/components/buttons';
import { Badge } from '@/components/typography';
import {
  CAMPAIGN_GROUP_MAX_LIMIT,
  CAMPAIGN_GROUP_MIN_LIMIT,
  CAMPAIGN_SCORE_MAX_LIMIT,
  CAMPAIGN_SCORE_MIN_LIMIT,
} from '@/constants';
import { ROUTES } from '@/router';

type Props = {
  selectedCampaigns: CampaignActivityDataType[];
  onRemoveSelectedCampaign: (campaign: CampaignActivityDataType) => void;
  onScoreCampaigns: (campaigns: string[]) => void;
};

const CampaignTableActionContent = ({
  selectedCampaigns,
  onRemoveSelectedCampaign,
  onScoreCampaigns,
}: Props) => {
  const selectedCampaignIds = useMemo(
    () => selectedCampaigns.map((campaign) => campaign.ad.id),
    [selectedCampaigns],
  );

  const disableScore =
    selectedCampaigns.length < CAMPAIGN_SCORE_MIN_LIMIT ||
    selectedCampaigns.length > CAMPAIGN_SCORE_MAX_LIMIT;
  const disableGroup =
    selectedCampaigns.length < CAMPAIGN_GROUP_MIN_LIMIT ||
    selectedCampaigns.length > CAMPAIGN_GROUP_MAX_LIMIT;

  return (
    <div className="flex items-start gap-4">
      <div className="flex flex-col gap-2">
        <Button disabled={disableScore} onClick={() => onScoreCampaigns(selectedCampaignIds)}>
          <Trans>Score {disableScore ? '' : ` (${selectedCampaigns.length})`}</Trans>
        </Button>
        <LinkButton disabled={disableGroup} to={ROUTES.campaignGroupByIds(selectedCampaignIds)}>
          <Trans>Group {disableGroup ? '' : ` (${selectedCampaigns.length})`}</Trans>
        </LinkButton>
      </div>
      <div className="flex flex-wrap gap-1">
        {selectedCampaigns.map((campaign) => (
          <Badge key={campaign.ad.id} closable onClose={() => onRemoveSelectedCampaign(campaign)}>
            {campaign.ad.name}
          </Badge>
        ))}
      </div>
    </div>
  );
};

export default CampaignTableActionContent;
